import './styles.scss'

const igLoadNode = document.querySelector('#ig-load')

if (igLoadNode) {
    fetch('/local/templates/main/include/instagram.php')
    .then(response => response.text())
    .then((data) => {
        igLoadNode.innerHTML = data
    })
}